import { PButton, componentsReady } from '@porsche-design-system/components-react';
import { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';

type ImageOverlayProps = {
    isFullscreen: boolean;
    setIsFullscreen: (isFullscreen: boolean) => void;
};

const zoomButtonCss = css`
    :host .root {
        background-color: #fbfcff;
        border: none;
    }

    :host .root:hover {
        background-color: #afb0b3;
        border-color: #afb0b3;
    }
`;

const MainImageOverlay = styled.div`
    position: absolute;
    z-index: 50;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

const ButtonWrapper = styled.div`
    position: absolute;
    bottom: clamp(16px, 1.25vw + 12px, 36px);
    right: clamp(16px, 1.25vw + 12px, 36px);
`;

const useOverlayStyle = (overlayRef: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
        if (!overlayRef.current) {
            return;
        }

        const container = overlayRef.current;

        componentsReady(container).then(() => {
            const buttonShadowRoot = container.querySelector('p-button')?.shadowRoot;

            if (buttonShadowRoot) {
                const style = document.createElement('style');
                style.textContent = zoomButtonCss.toString();
                buttonShadowRoot.appendChild(style);
            }
        });
    }, [overlayRef]);
};

const ImageOverlay = ({ isFullscreen, setIsFullscreen }: ImageOverlayProps) => {
    const overlayRef = useRef<HTMLDivElement>(null);
    useOverlayStyle(overlayRef);

    const handleZoom = () => setIsFullscreen(!isFullscreen);

    return (
        <MainImageOverlay ref={overlayRef} onClick={handleZoom}>
            <ButtonWrapper>
                <PButton
                    icon={isFullscreen ? 'zoom-in' : 'zoom-out'}
                    onClick={handleZoom}
                    type="button"
                    variant="secondary"
                    hideLabel
                >
                    {isFullscreen ? 'Zoom In' : 'Zoom Out'}
                </PButton>
            </ButtonWrapper>
        </MainImageOverlay>
    );
};

export default ImageOverlay;
